import { HttpParams } from '@angular/common/http';
import { ApiParams } from 'shared/services';

export class OptionsToParams {
  private static shouldAddParam = (
    value: string[] | string | boolean
  ): {
    shouldAddParam: boolean;
    isParamArray: boolean;
  } => {
    const isParamArray = Array.isArray(value);
    const isParamBoolean = typeof value === 'boolean';
    if (isParamBoolean) {
      return { shouldAddParam: isParamBoolean, isParamArray };
    }
    const shouldAddParam = isParamArray ? value.length > 0 : !!value;
    return {
      shouldAddParam,
      isParamArray,
    };
  };

  public static processOptionsToParams<T>(params: HttpParams, options: ApiParams<T>): HttpParams {
    Object.entries(options).forEach(([key, value]) => {
      const { shouldAddParam, isParamArray } = this.shouldAddParam(value);
      if (shouldAddParam) {
        params = isParamArray ? params.appendAll({ [key]: value }) : params.append(key, value);
      }
    });
    return params;
  }
}
